import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import 'what-input';
import "./styleguide.css"
import "./globals.css";


ReactDOM.render(<App />, document.getElementById("app"));